import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

const SchoolEditSubject = () => {
  const [schoolClassName, setSchoolClassName] = useState([]);
  const [schoolSubjectName, setSchoolSubjectName] = useState("");
  const [reference, setReference] = useState("");
  const [subjectUploadIcon, setSubjectUploadIcon] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams(); // Get subject ID from URL

  const handleAddNewSubject = () => {
    navigate("/school-add-subject");
  };

  const handleViewAllSubjects = () => {
    navigate("/school-all-subject");
  };

  useEffect(() => {
    // Fetch all classes for the dropdown
    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) => {
        setSchoolClassName(resp.data.data);
      })
      .catch((error) => {
        console.error("Error fetching classes:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch existing subject details for editing
    axios
      .get(`${API_BASE_URL}/subjects/${id}`)
      .then((resp) => {
        const subjectData = resp.data.data;
        setSchoolSubjectName(subjectData.subjectName);
        setReference(subjectData.classId); // Adjust to match response structure
      })
      .catch((error) => {
        console.error("Error fetching subject details:", error);
      });
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("subjectName", schoolSubjectName);
    // formData.append("classId", reference);
    if (subjectUploadIcon) formData.append("icon", subjectUploadIcon);

    try {
      await axios.put(`${API_BASE_URL}/subjects/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("Subject updated successfully");
      navigate("/school-all-subject"); // Navigate to all subjects page
    } catch (error) {
      console.error("Error updating subject:", error);
      alert("Failed to update subject");
    }
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Subject</h5>
          <div className="subjectdiv2">
            <button className="handleNewSubject" onClick={handleAddNewSubject}>
              + Add New Subject
            </button>
            <button className="allSubjects" onClick={handleViewAllSubjects}>
              All Subjects
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Edit Subject Details</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            {/* <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Class Name</label>
              </div>
              <select
                className="select-dropdown"
                value={reference}
                onChange={(e) => setReference(e.target.value)}
                required
              >
                <option value="">-Select Class-</option>
                {schoolClassName.map((classItem) => (
                  <option value={classItem._id} key={classItem._id}>
                    {classItem.className}
                  </option>
                ))}
              </select>
            </div> */}

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Subject</label>
              </div>
              <input
                type="text"
                placeholder="Enter Subject"
                value={schoolSubjectName}
                onChange={(e) => setSchoolSubjectName(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Upload Icon</label>
              </div>
              <input
                type="file"
                id="subject-upload-icon"
                onChange={(e) => setSubjectUploadIcon(e.target.files[0])}
              />
            </div>

            <div className="school-subj-form-btns">
              <button className="btn-search" type="submit">
                Save
              </button>
              <button
                className="btn-cancel"
                type="button"
                onClick={() => navigate("/school-all-subject")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SchoolEditSubject;
